import type { ComponentProps } from 'react';

const ArrowForward = (props: ComponentProps<'svg'> & { color?: string }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0297 6.53145C11.3227 6.23848 11.3227 5.7627 11.0297 5.46973L7.27969 1.71973C6.98672 1.42676 6.51094 1.42676 6.21797 1.71973C5.925 2.0127 5.925 2.48848 6.21797 2.78145L8.69062 5.25176H1.5C1.08516 5.25176 0.75 5.58691 0.75 6.00176C0.75 6.4166 1.08516 6.75176 1.5 6.75176H8.68828L6.22031 9.22207C5.92734 9.51504 5.92734 9.99082 6.22031 10.2838C6.51328 10.5768 6.98906 10.5768 7.28203 10.2838L11.032 6.53379L11.0297 6.53145Z"
        fill={props?.color ?? '#203248'}
      />
    </svg>
  );
};

export default ArrowForward;
